module.exports = __webpack_public_path__ + "img/case4.8a0baff4.png";